export interface FormCourse {
  index: number;
  lastIndex: number | null | undefined;
  CNGradingScale: string;
  grade: number[];
  finalGrade: string;
  credits: number[];
  finalCredits: string;
  checkedNA: false;
  otherGradeScale: string;
  highestGrade: string;
  lowestGrade: string;
  subject: string;
  courseName: string;
  class: string;
  otherClass: string;
  typeOfClass: string;
  isTakeClassAtCollege: boolean;
  collegeTookClass: string;
  schedule_transcript: string;
  isFirstSemester: boolean;
  isSecondSemester: boolean;
  isThirdSemester: boolean;
  isFourthSemester: boolean;
  isTakeIn678Grade: boolean;
  isUsedBlockScheduling: boolean;
  classOccurredDuringTime: string; // x
  classOccurredDuringGrade: string; //x
  schoolName: string; //x
  schoolYear: string; //x
  schoolCode: string;
  CMGradingScale: string; //x
  schedule: string; // x
  otherSchedule: string; // x
  subjectDetails: SubjectDetail[];
  number_of_summer_courses: number;
  have12thGradeCourses: string;
  allNoneAGCourses: boolean;
}

export interface SubjectDetail {
  index: number;
  lastIndex: number | null | undefined;
  isWeightedCourse: string;
  languageName: string;
  CNGradingScale: string;
  grade: (number | string)[];
  finalGrade: string;
  credits: (number | string)[];
  finalCredits: string;
  checkedNA: false;
  otherGradeScale: string;
  highestGrade: string;
  lowestGrade: string;
  subject: string;
  AGSubjectArea: string;
  courseName: string;
  courseId?: number;
  class: string;
  otherClass: string;
  schedule_transcript: string;
  isFirstSemester: boolean;
  isSecondSemester: boolean;
  isThirdSemester: boolean;
  isFourthSemester: boolean;
  isTakeIn678Grade: boolean;
  isUsedBlockScheduling: boolean;
  typeOfClass: string;
  isTakeClassAtCollege: boolean;
  collegeTookClass: string;
  isSummerCourse: boolean;
  isNew?: boolean;

}

export const subjectDetailModal: SubjectDetail = {
  index: -1,
  isWeightedCourse: '',
  CNGradingScale: '',
  grade: ['', '', '', ''],
  finalGrade: '',
  credits: ['', '', '', ''],
  finalCredits: '',
  checkedNA: false,
  otherGradeScale: '',
  highestGrade: '',
  lowestGrade: '',
  subject: '--',
  AGSubjectArea: '',
  courseName: '',
  class: '',
  otherClass: '',
  schedule_transcript: '',
  isFirstSemester: false,
  isSecondSemester: false,
  isThirdSemester: false,
  isFourthSemester: false,
  isTakeIn678Grade: false,
  isUsedBlockScheduling: false,
  typeOfClass: '',
  isTakeClassAtCollege: false,
  collegeTookClass: '',
  languageName: '',
  isSummerCourse: false,
  lastIndex: null
};


export interface FormCollegeCourse {
  index: number;
  lastIndex: number | null | undefined;
  collegeName: string;
  collegeInformation: any;
  scheduleSystem: string;
  academicYear: string;
  term: string;
  academicStatus: string;
  collegeCourseArray: CollegeCourseDetail[];
};
export interface CollegeCourseDetail {
  index: number;
  lastIndex: number | null | undefined;
  dept: string;
  collegeCourseSubject: string;
  courseName: string;
  courseNumber: string;
  subject: string;
  languageName: string;
  creditsPerHours: string;
  grade: string;
  honorStatus: string;
  completionStatus: string;
  transferable: boolean;
};
